import React from 'react'

import { BlockContainer } from '@Components/BlockContainer'
import { ShippingPricingV1 } from '@Components/Shipping/ShippingPricing/v1'
import { ShippingPricingV2 } from '@Components/Shipping/ShippingPricing/v2'
import { Block } from '@Generated/graphql'
import { getJSONFieldValue } from '@Globals/CMS/FieldHelpers'
import { useSplitTest } from '@Globals/SplitTests/Hooks'

const ShippingMatrixBlock = ({
  data,
  id,
}: {
  data: Block
  id?: string
}) => {
  const showFreeShippingDescription = React.useMemo(
    () => getJSONFieldValue<boolean>(data.fields || [], 'showFreeShippingDescription') || false,
    [data],
  )
  const shippingPricingV2 = useSplitTest('shipping_threshold_discount_v1', 'b')

  if (shippingPricingV2) {
    const { appearance, common } = data

    return (
      <BlockContainer
        appearance={appearance || {}}
        className="fullwidth"
        common={common || {}}
        id={id}
        noPadding
      >
        <ShippingPricingV2 showFreeShippingDescription={showFreeShippingDescription} />
      </BlockContainer>
    )
  }

  return <ShippingPricingV1 id={id} showFreeShippingDescription={showFreeShippingDescription} />
}

export default ShippingMatrixBlock
